export const EmptyGuid = "00000000-0000-0000-0000-000000000000";
export const EmptyImageDataStream = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAMSURBVBhXY/j//z8ABf4C/qc1gYQAAAAASUVORK5CYII=";

export const SyncfusionLicenceKey = 'ORg4AjUWIQA/Gnt2VFhhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5WdkFjUXtddXJUR2NV';

export const MethodNotAllowedMessage = "Could not perform action.";
export const ConcurrencyErrorMessage = "Changes have been made since this page was loaded. Please refresh the page.";

export const FileTypeImageId = "f4becaa9-bd9f-4ca9-810d-5816d9df2df3";
export const FileTypeHtmlId = "3fb8421c-c62a-47e7-808c-6a80310a2399";
export const FileTypeOfficeId = "f3cd09cc-8d2c-468a-9e2a-3640bfda0a77";
export const FileTypeGDocsId = "c1f25d8a-9b3c-4717-a71f-36c76ed02ed6";
export const FileTypeTextId = "ad476ff5-b79e-4a33-bf68-6aa248473bee";
export const FileTypeVideoId = "4c384976-1f78-4a9e-9cf1-450d02bbae9b";
export const FileTypeAudioId = "5267f47d-2dad-41d0-9264-e0ad171e2321";
export const FileTypeFlashId = "395d2eb6-522f-415d-a688-c477296abbe2";
export const FileTypePdfId = "4c4f6c97-bd7e-411f-846c-fa97baf856c6";

export const FileTypesToAcceptedFileTypes: {[fileTypeId: string]: string } = {
    [FileTypeImageId]: "image/*",
    [FileTypeHtmlId]: "text/html",
    [FileTypeOfficeId]: ".doc, .docx, .xls, .xlsx, .ppt, .pptx, .pps, .pot, .potx",
    [FileTypeGDocsId]: ".doc, .docx, .xls, .xlsx, .ppt, .pptx, .pps, .pot, .potx, .rtf, .ods, .odt, .pages, .ai, .dxf, .ttf, .tif, .tiff, .wmf , .eps, .ps",
    [FileTypeTextId]: "text/*",
    [FileTypeVideoId]: "video/*",
    [FileTypeAudioId]: "audio/*",
    [FileTypeFlashId]: "application/x-shockwave-flash",
    [FileTypePdfId]: "application/pdf",
}

/// <summary>
/// Scope names which help us inform the browser when to fetch new data
/// </summary>
export class BrowserCacheScopes {
    /// <summary>
    /// Refresh cache when system is restarted
    /// </summary>
    public static SystemDataChanged = "SystemDataChanged";
}

export class DataAttributeNames {
    public static DomRootFieldTags = 'trifort-cms-field-tags';
}